export const basicTextGql = /* GraphQL */ `
... on blogContent_basicText_BlockType {
    typeHandle
    description:basicTextDescription
    basicTextEyebrow
    basicTextTitle
    mainButtons:buttons
    columns
    colors
    textAlignment
    textBlocks:textBlocksBlog {
        ... on textBlocksBlog_BlockType {
            blockButtons:buttons
            eyebrow
            subheader
            text
            textAlignment
        }
    }
}`;
